import { render } from "./VacanciesView.vue?vue&type=template&id=517215a4&scoped=true&ts=true"
import script from "./VacanciesView.vue?vue&type=script&lang=ts"
export * from "./VacanciesView.vue?vue&type=script&lang=ts"

import "./VacanciesView.vue?vue&type=style&index=0&id=517215a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517215a4"]])

export default __exports__